export const isBreakpointXl: (window) => boolean = (window) => window.innerWidth < 1280;
export const isBreakpointLg: (window) => boolean = (window) => window.innerWidth < 1024;
export const isBreakpointMd: (window) => boolean = (window) => window.innerWidth < 768;
export const isBreakpointSm: (window) => boolean = (window) => window.innerWidth < 640;
